<template>
  <div class="logo" @click="$router.push({name: 'home'})">
    <!--<a href="javascript:void(0);"></a>-->
    <img :src="logo"/>
  </div>
</template>

<script>
  export default {
    props: {
      logo: {
        type: String,
        default: ''
      }
    }

  }
</script>

<style lang="scss" scoped>
  .logo {
    cursor: pointer;
    font-size: 24px;
    font-weight: 700;
    line-height: $_header_height;
    display: inline-block;
    vertical-align: middle;

    img {
      margin: 16px 0;
      width: auto;
      height: auto;
    }

    a {
      display: inline-block;
      width: 240px;
      margin: 10px 8px;
      height: 32px;
      background: url("../../assets/img/logo.png") no-repeat;
      background-size: cover;
      position: relative;
      top: -3px;
      vertical-align: middle;
    }
  }
</style>
